import React from "react";
import Upload from 'rc-upload';
import axios from 'axios'

export default class extends React.Component {


    constructor() {
        super();
        this.onStart = this.onStart.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.onProgress = this.onProgress.bind(this);
        this.onError = this.onError.bind(this);

        this.state = {
            status: "upload",
            files: []
        }

    }

    onStart(file) {
        this.setState({
            status: "uploading"
        })
    }

    onSuccess(res, file) {
        this.setState({
            status: "uploaded"
        });
        this.props.onUploaded && this.props.onUploaded(res[0]);
    }

    onProgress({percent}, file) {
        console.log('onProgress', `${percent}%`, file.name);
    }

    onError(err) {
        this.setState({
            status: "error"
        });
    }

    customRequest(opinions) {
        const {
            action,
            file,
            onError,
            onProgress,
            onSuccess,
        } = opinions;

        const formData = new FormData();
        if(file.name.split(".").length<2){
            return 
        }
        const filename = (new Date()).getTime() + "."+file.name.split(".").pop();
        formData.append('smartsheet/' + file.uid, file,filename);
        axios.post(action, formData, {
            withCredentials: true,
            headers: PlatformSDK.generateCsrfToken(),
            onUploadProgress: ({total, loaded}) => {
                onProgress({percent: Math.round(loaded / total * 100).toFixed(2)}, file);
            },
        }).then(({data: response}) => {
            onSuccess(response, file);
        }).catch(onError);

        return {
            abort() {
                console.log('upload progress is aborted.');
            },
        };
    }


    generateUploader() {
        const accept = 'image/png, image/jpeg, .svg';
        const upload_url = PubHub.APIHost + '/v1/uploadfile/storage';
        return <Upload
            className={"d-block"}
            accept={accept}
            multiple={false}
            headers={PlatformSDK.generateCsrfToken()}
            withCredentials={true}
            action={upload_url}
            onStart={this.onStart}
            onSuccess={this.onSuccess}
            onProgress={this.onProgress}
            onError={this.onError}
            customRequest={this.customRequest}
            tabIndex="-1"
            >
            <div className="upload" ><i className="fas fa-image" title="Upload image"></i><span>Upload image</span></div>
        </Upload>
    }

    






    render() {
        if (this.state.status == "uploading") {
            return <div className="upload"><i className="fas fa-spinner"></i></div>
        }

       
        return this.generateUploader();

    }
}